import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useState } from "react";

const CONTENT_WIDTH_CLASSES = {
  standard: "max-w-[1180px]",
  wide: "max-w-[1240px]",
  map: "max-w-[1480px]",
};

function CollapseQuickFactsButton({
  color,
  expanded,
  handleCollapse,
  variant = "legacy-strip",
}) {
  return (
    <button
      style={{ backgroundColor: color }}
      className={`inline-flex items-center gap-2 text-white transition hover:brightness-95 ${
        variant === "inline-card"
          ? "rounded-[4px] px-4 py-1.5 text-sm font-semibold shadow-sm"
          : "rounded-b-full px-6 pb-1"
      }`}
      onClick={handleCollapse}
      type="button"
    >
      <VisibilityOutlinedIcon fontSize="small" />
      {expanded ? "Hide Quick Facts" : "View Quick Facts"}
    </button>
  );
}

export default function QuickFacts({
  sectionColor,
  dashboardData = false,
  quickFactsData = null,
  contentWidth = "standard",
  variant = "legacy-strip",
  embedded = false,
}) {
  var QuickFactsDummyData;

  if (dashboardData === false) {
    QuickFactsDummyData = quickFactsData || [];
  } else {
    QuickFactsDummyData = dashboardData;
  }

  const [isQuickFactsCollapsed, setIsQuickFactsCollapsed] = useState(true);
  const contentWidthClass =
    CONTENT_WIDTH_CLASSES[contentWidth] || CONTENT_WIDTH_CLASSES.standard;

  function handleCollapse() {
    setIsQuickFactsCollapsed(!isQuickFactsCollapsed);
  }

  if (variant === "inline-card") {
    return (
      <div className={`w-full ${embedded ? "" : "px-4 pt-4 md:px-6"}`}>
        <div className={`${embedded ? "" : "mx-auto "}w-full ${contentWidthClass}`}>
          <div className="flex justify-start">
            <CollapseQuickFactsButton
              color={sectionColor}
              expanded={!isQuickFactsCollapsed}
              handleCollapse={handleCollapse}
              variant={variant}
            />
          </div>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              isQuickFactsCollapsed
                ? "pointer-events-none mt-0 max-h-0 opacity-0"
                : "mt-4 max-h-[480px] opacity-100"
            }`}
          >
            <div className="rounded-[8px] border border-slate-200 bg-white p-3 shadow-[0_10px_24px_rgba(15,23,42,0.04)] md:p-4">
              <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
                {QuickFactsDummyData.map((cellData) => (
                  <div
                    className="relative rounded-[8px] border border-slate-200 bg-[#fcfcfa] px-4 pb-2.5 pt-3.5"
                    key={cellData.label}
                  >
                    <p className="absolute left-3 top-0 -translate-y-1/2 bg-[#fcfcfa] px-2 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">
                      {cellData.label}
                    </p>
                    <p className="text-[15px] leading-6 text-slate-700">
                      {cellData.value || "Not available"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const displayAs = isQuickFactsCollapsed
    ? "0px"
    : dashboardData
      ? "95px"
      : "145px";

  return (
    <div className="w-full flex flex-col items-center">
      <div
        style={{
          borderBottom: `1px solid ${sectionColor}`,
          height: displayAs,
        }}
        className="h-[145px] w-full overflow-hidden transition-all duration-300"
      >
        <div className="w-full grid grid-cols-3 gap-4 p-4">
          {QuickFactsDummyData.map((cellData) => {
            return (
              <div key={cellData.label}>
                <p className="text-[#666666]  truncate border-b border-dotted border-[#666666]">
                  <span className="font-bold">{cellData.label}:</span>{" "}
                  <span>{cellData.value}</span>
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <CollapseQuickFactsButton
        color={sectionColor}
        expanded={!isQuickFactsCollapsed}
        handleCollapse={handleCollapse}
        variant={variant}
      />
    </div>
  );
}
